import { VenueBreadcrumbReactionSummaryDto } from '@ivy-monorepo/shared'
import FormItem from './FormItem'
import BreadcrumbReactionsSummary from './BreadcrumbReactionsSummary'
import ModerationActionsBar, { ModerationActionsConfig } from './moderation/ModerationActionsBar'

export interface BreadcrumbActivityMetaItem {
  label: string
  value: string
  type?: 'datetime'
}

interface BreadcrumbActivityBoxProps {
  title: string
  variant: 'breadcrumb' | 'reply'
  content: string
  meta: BreadcrumbActivityMetaItem[]
  reactions?: VenueBreadcrumbReactionSummaryDto[]
  moderation?: ModerationActionsConfig
}

const BreadcrumbActivityBox = ({ title, variant, content, meta, reactions, moderation }: BreadcrumbActivityBoxProps) => {
  const isFlagged = moderation?.isFlagged ?? false

  return (
    <div
      className={`breadcrumb-activity-box breadcrumb-activity-box--${variant}${isFlagged ? ' breadcrumb-activity-box--flagged' : ''}`}
    >
      <div className="breadcrumb-activity-box-header">
        <h3>{title}</h3>
        {moderation && <ModerationActionsBar {...moderation} variant="icons" />}
      </div>
      <div className="breadcrumb-activity-content">{content}</div>
      <div className="breadcrumb-activity-meta">
        {meta.map(item => (
          <FormItem key={item.label} label={item.label} value={item.value} type={item.type} />
        ))}
        <div className="breadcrumb-activity-reactions">
          <span className="breadcrumb-activity-reactions-label">Reactions</span>
          <BreadcrumbReactionsSummary reactions={reactions} />
        </div>
      </div>
    </div>
  )
}

export default BreadcrumbActivityBox
